import { Constants } from "../Constants";
import BaseApi from "./BaseApi";

class IdentityApi extends BaseApi {
  constructor() {
    super(
      process.env.REACT_APP_baseAuthUrl,
      Constants.CLIENT_TOKEN_KEY,
      Constants.CLIENT_TOKEN_EXPIRATION
    );
    this.tokenPath = "/connect/token";

    this.register = this.register.bind(this);
    this.loginClient = this.loginClient.bind(this);
    this.loginUser = this.loginUser.bind(this);
    this.isAvailable = this.isAvailable.bind(this);
    this.validateRequestedEmail = this.validateRequestedEmail.bind(this);
    this.clearUserTokens = this.clearUserTokens.bind(this);
    this.confirmEmail = this.confirmEmail.bind(this);
    this.sendConfirmationEmail = this.sendConfirmationEmail.bind(this);
    this.loginClientOnNeed = this.loginClientOnNeed.bind(this);
  }

  async getStoredUserInfo() {
    const userName = window.localStorage.getItem(Constants.USERNAME_KEY);
    const password = window.localStorage.getItem(Constants.PASSWORD_KEY);

    if (userName != null && password != null) {
      return { userName, password };
    } else {
      return null;
    }
  }

  async isUserLoginExpired() {
    const val = window.localStorage.getItem(Constants.USER_TOKEN_EXPIRATION);
    if (val === null) {
      return true;
    }

    const tokenExpiration = parseInt(val);
    const isExpired = Date.now() > tokenExpiration;
    return isExpired;
  }

  async register(userName, password) {
    const authToken = await this.getCurrentValidToken(
      Constants.CLIENT_TOKEN_KEY,
      Constants.CLIENT_TOKEN_EXPIRATION
    );
    if (!authToken) {
      await this.loginClient();
    }
    const obj = { userName: userName, password: password };
    this.clearUserTokens();
    const response = await this.getAxios().post(
      "/api/account/register",
      obj,
      this.jsonEncoded
    );
    return response;
  }

  async isAvailable(userName) {
    const authToken = await this.getCurrentValidToken(
      Constants.CLIENT_TOKEN_KEY,
      Constants.CLIENT_TOKEN_EXPIRATION
    );
    if (!authToken) {
      await this.loginClient();
    }
    try {
      const response = await this.getAxios().get(
        "/api/account/isavailable",
        { params: { email: userName } },
        this.jsonEncoded
      );
      return response;
    } catch (err) {
      //not good
      //need to notify us about this

      return false;
    }
  }

  async loginClientOnNeed() {
    const authToken = await this.getCurrentValidToken(
      Constants.CLIENT_TOKEN_KEY,
      Constants.CLIENT_TOKEN_EXPIRATION
    );
    if (!authToken) {
      await this.loginClient();
    } else {
    }
  }

  async sendConfirmationEmail(email) {
    await this.loginClientOnNeed();
    try {
      const requestedUri = `${window.location.protocol}//${
        window.location.hostname
      }${window.location.port ? ":" + window.location.port : ""}`;
      await this.getAxios().get(
        "/api/account/sendconfirmationemail",
        {
          params: {
            email,
            applicationContext: Constants.APPLICATION_NAME,
            requestedUri,
          },
        },
        this.jsonEncoded
      );
      return true;
    } catch (err) {
      console.log("Failed to request email confirmation");
      console.log(err);
      return false;
    }
  }

  async requestPasswordChange(email) {
    await this.loginClientOnNeed();
    try {
      const requestedUri =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
      console.log(requestedUri);
      const response = await this.getAxios().get(
        "/api/account/requestpasswordchange",
        {
          params: {
            email: email,
            applicationContext: Constants.APPLICATION_NAME,
            requestedUri,
          },
        },
        this.jsonEncoded
      );
      return response;
    } catch (err) {
      //not good
      //need to notify us about this

      return false;
    }
  }

  async changePasswordUsingToken(email, newPassword, token) {
    await this.loginClientOnNeed();
    try {
      const response = await this.getAxios().get(
        "/api/account/changepasswordusingtoken",
        {
          params: {
            email,
            newPassword,
            token,
          },
        },
        this.jsonEncoded
      );
      return response;
    } catch (err) {
      //not good
      //need to notify us about this

      return false;
    }
  }

  async confirmAccount(email, password, token) {
    await this.loginClientOnNeed();
    try {
      const response = await this.getAxios().get(
        "/api/account/confirmaccount",
        {
          params: {
            email,
            password,
            token,
          },
        },
        this.jsonEncoded
      );
      return response;
    } catch (err) {
      //not good
      //need to notify us about this

      return false;
    }
  }

  async confirmEmail(email, token) {
    await this.loginClientOnNeed();
    try {
      const response = await this.getAxios().get(
        "/api/account/confirmemail",
        {
          params: {
            email,
            token,
          },
        },
        this.jsonEncoded
      );
      return response;
    } catch (err) {
      //not good
      //need to notify us about this

      return false;
    }
  }

  async validateRequestedEmail(userName) {
    await this.loginClientOnNeed();
    try {
      const response = await this.getAxios().get(
        "/api/account/validaterequestedemail",
        { params: { email: userName } },
        this.jsonEncoded
      );
      return response;
    } catch (err) {
      //not good
      //need to notify us about this

      return false;
    }
  }

  clearUserTokens() {
    window.localStorage.removeItem(Constants.USER_TOKEN_KEY);
    window.localStorage.removeItem(Constants.USER_TOKEN_EXPIRATION);
  }

  async loginClient() {
    const params = new URLSearchParams();
    params.append("client_id", Constants.CLIENT_ID);
    params.append(
      "client_secret",
      encodeURIComponent(process.env.REACT_APP_clientSecret)
    );
    params.append("grant_type", "client_credentials");
    params.append("scope", Constants.CLIENT_SCOPE);
    const result = await this.getAxios().post(
      this.tokenPath,
      params,
      this.formEncoded
    );
    const authToken = result.data.access_token;
    const authTokenExpiration = Date.now() + result.data.expires_in * 1000;
    window.localStorage.setItem(Constants.CLIENT_TOKEN_KEY, authToken);
    window.localStorage.setItem(
      Constants.CLIENT_TOKEN_EXPIRATION,
      "" + authTokenExpiration
    );
    return result;
  }

  async loginUser(userName, password) {
    const params = new URLSearchParams();
    params.append("client_id", Constants.CLIENT_ID);
    params.append(
      "client_secret",
      encodeURIComponent(process.env.REACT_APP_clientSecret)
    );
    params.append("grant_type", "password");
    params.append("username", userName);
    params.append("password", password);
    params.append("scope", Constants.USER_SCOPE);
    this.useToken = false;
    let result;
    try {
      result = await this.getAxios().post(
        this.tokenPath,
        params,
        this.formEncoded
      );
      this.useToken = true;
    } catch (err) {
      this.useToken = true;
      throw err;
    }
    const apiToken = result.data.access_token;
    const apiTokenExpiration = Date.now() + result.data.expires_in * 1000;
    window.localStorage.setItem(Constants.USER_TOKEN_KEY, apiToken);
    window.localStorage.setItem(
      Constants.USER_TOKEN_EXPIRATION,
      "" + apiTokenExpiration
    );
    window.localStorage.setItem(Constants.USERNAME_KEY, userName);
    return result;
  }

  // This is called when you need to verify the user's password before allowing some action. (ex. updating username)
  async verifyPassword(userName, password) {
    const params = new URLSearchParams();
    params.append("client_id", Constants.CLIENT_ID);
    params.append(
      "client_secret",
      encodeURIComponent(process.env.REACT_APP_clientSecret)
    );
    params.append("grant_type", "password");
    params.append("username", userName);
    params.append("password", password);
    params.append("scope", Constants.USER_SCOPE);
    this.useToken = false;
    const result = await this.getAxios().post(
      this.tokenPath,
      params,
      this.formEncoded
    );
    return result;
  }
}

export default IdentityApi;
